import {Injectable, OnDestroy} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {AuthenticationService} from '../../services/authentication.service';
import {AppConfig} from '../../app.config';
import {catchError, combineLatestWith, retry, throttleTime} from 'rxjs/operators';
import {Observable} from 'rxjs/internal/Observable';
import {throwError} from 'rxjs/internal/observable/throwError';
import {Subscription} from 'rxjs/internal/Subscription';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { ProjectService } from 'src/app/services/project.service';
import { NotificationService } from '../../services/notification.service';

@Injectable()
export class VisitorService implements OnDestroy {

  private static RETRIES = 10;
  private projectIdSubscription: Subscription = null;

  private visitorsSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  public visitors$ = this.visitorsSubject.asObservable();
  private dataSubscription: Subscription;

  constructor(
    private authService: AuthenticationService,
    private projectService: ProjectService,
    private notificationService: NotificationService
  ) {

    this.projectIdSubscription = notificationService.newVisitor$.
      pipe( 
        combineLatestWith( this.projectService.getSelectedProjectId() ),
        throttleTime(5000, null, { trailing: true }),
        catchError(this.handleError)
      )
      .subscribe(
        ([event,projectId]) => {
          // this.badgeValueService.populateBadgeValues();
          
          if ( projectId == null ) {
            return;
          }

          this.fetchData( projectId ).subscribe({
            next: (data) => {
              this.visitorsSubject.next( data );
            }
          })
        }

    );

  }

 private fetchData( projectId ) {
    const antiCache = '&ac=' + new Date().getTime()
    return this.authService.get( AppConfig.BASE_URL + AppConfig.VISITOR_ENDPOINT + projectId + antiCache );
  } 

  export(projectId): Observable<any> {
    const url = AppConfig.BASE_URL + AppConfig.VISITOR_CSV_ENDPOINT;
    const options = this.authService.getDefaultReqOptions();
    options.responseType = 'text';
    return this.authService.get(url + projectId, options);
  }

  ngOnDestroy(): void {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
    if (this.projectIdSubscription) {
      this.projectIdSubscription.unsubscribe();
    }
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError (() =>
      'Something bad happened; please try again later.');
  }

}

